import { React, useState, forwardRef, useImperativeHandle, useRef, useEffect } from 'react';
import styled from 'styled-components';
import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';
import { useLanguage } from '../../Context/LanguageContext';

import { ReactComponent as LeftArrowSvg } from '../../image/LeftArrow.svg';
import InfiniteImage from '../../image/Infinite.png';

const IndexMemberShipMaxCountInput = forwardRef((props, ref) => {
  const { dateVal, setDateVal, explanation, isRegularPayment, unit, index } = props;

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const { t } = useLanguage();

	const [changed, setChanged] = useState(false);
  const [noLimit, setNoLimit] = useState(false);

  const InputRef = useRef();

  useImperativeHandle(ref, () => ({
		setValue: (val) => {
      if (val === -1) {
        setDateVal(0, index);
        setNoLimit(true);
      }
      else{
        setDateVal(val, index);
        setNoLimit(false);
      }
		},
		getValue: () => {
      if (noLimit) return -1;
      else return dateVal;
		},
    reset: (noLimit) => {
      setDateVal(0);
      setNoLimit(noLimit);
    }
	}))

  useEffect(() => {
    if (dateVal === -1) setNoLimit(true);
  }, [dateVal])

	function handleChange(e) {
    var regex = /[^0-9]/g;				// 숫자가 아닌 문자열을 매칭하는 정규식
    var result = e.target.value.replace(regex, "");	// 원래 문자열에서 숫자가 아닌 모든 문자열을 빈 문자로 변경
   
    if (e.target.value === '') setDateVal(0, index);
		else setDateVal(parseInt(result), index);
		setChanged(true);
	}

	function handleFocus(e) {

	}

  function upButtonClick() {
    if (noLimit) return;
    setDateVal(dateVal + 1, index);
  }

  function downButtonClick(){
    if (noLimit) return;
    if (dateVal > 0) setDateVal(dateVal - 1, index);
  }

  function onClickNoLimit() {
    if (noLimit && dateVal === -1) setDateVal(0, index);

    setNoLimit(!noLimit);
  }
  return (
    <TopLevelWrapper>
      <ExplanationWrapper>
        <Explanation>{explanation}</Explanation>
        {
          !isRegularPayment &&
          <LimitWrapper>
            <Image width={17} height={8} src={InfiniteImage} />
            <LimitCheckBox noLimit={noLimit} onClick={onClickNoLimit} />
          </LimitWrapper>
        }
      </ExplanationWrapper>
      <InputWrapper>
        <Input 
          disabled={noLimit}
          ref={InputRef}
          placeholder={0}
          value={noLimit ? t('system.noLimit') : dateVal}
          onChange={handleChange}
          onFocus={handleFocus}/>
        <ButtonWrapper>
          <Button onClick={upButtonClick}><StyledArrow isUp={true} /></Button>
          <Button onClick={downButtonClick}><StyledArrow isUp={false} /></Button>
        </ButtonWrapper>
        <Text>{unit}</Text>
      </InputWrapper>
    </TopLevelWrapper>
  )
})

export default IndexMemberShipMaxCountInput;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
  
  transition: all 0.3s ease-in-out;
`;

const ExplanationWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const Explanation = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 12px;

  color: ${props => props.theme.subText};

  margin: 0 0 0 0;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: default;
    }
  }
`;

const LimitWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 4px;
`;

const LimitCheckBox = styled.div`
  display: flex;
  flex-direction: row;

  width: 14px;
  height: 14px;

  border: 1px solid ${props => props.theme.line};
  border-radius: 4px;

  margin-right: 2px;

  background-color: ${props => props.noLimit ? props.theme.primary : props.theme.subBackground};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const LimitText = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 12px;

  color: ${props => props.theme.subText};

  margin: 0 0 0 0;
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;
  
  margin-top: 8px;

  width: 100%;
`;

const Input = styled.input`
  display: flex;
  flex-direction: row;

  // width: calc(46.31% - 18px);
  width: 51px;
  height: 30px;

  border: 1px solid ${props => props.theme.line};
  border-radius: 8px;

  padding: 0 8px 0 8px;
  margin: 0 2px 0 0;


  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.text};
  background-color: ${props => props.theme.subBackground};

  &:disabled {
    color: ${props => props.theme.white};
    background-color: ${props => props.theme.primary};
  }

  transition: all 0.3s ease-in-out;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 2px;
`;

const Button = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 30px;
  height: 30px;

  border: 1px solid ${props => props.theme.buttonFill};
  border-radius: 8px;
  background-color: ${props => props.theme.buttonFill};

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const StyledArrow = styled(LeftArrowSvg)`
  width: 9.6px;
  height: 17.7px;

  transform: ${props => props.isUp ? 'rotate(90deg)' : 'rotate(-90deg)'};

  & path {
    fill: ${props => props.theme.subText};
  }
`;

const Text = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 12px;

  color: ${props => props.theme.subText};

  margin: 0 0 0 auto;
`;

const Image = styled.img`
  width: ${props => props.width}px;
  height: ${props => props.height}px;

  object-fit: contain;
`;